import axiosInstance from '@/shared/api/axiosInstance';

/**
 * Получение активных игр
 */
export const getGames = () => {
    return axiosInstance.get('/game-card-schedules/active');
};

/**
 * Запрос на оплату (создание бронирования и получение ссылки на оплату)
 * @param friendIds - ID друзей вписанных в модалке
 * @param {string} gameId - ID выбранной игры
 * @param isUsedPoints - Используются ли баллы для оплаты (или накапливать)
 * @param countPoints - количество используемых баллов, если они используются
 * @param isUsedPromo
 * @param isSolo - если выбрал с радио баттн с друзьями то true иначе false
 * @param promoCode Промокод
 * @returns {Promise<{ url: string }>}
 */
export const payForBooking = (
    friendIds,
    gameId,
    isUsedPoints,
    countPoints = 0,
    isUsedPromo,
    promoCode = null,
    isSolo,
) => {
    return axiosInstance.post(`/booking/${gameId}/pay`, {
        friendIds,
        isUsedPoints,
        countPoints,
        isSolo,
        promoCode,
        isUsedPromo
    });
};

/**
 * Получение количества всех и занятых мест
 * @param {string} gameId - ID выбранной игры
 * @returns {Promise<{ countMaxPlace: number, countCurrentPlace: number }>}
 */
export const getSeatCounts = (gameId) => {
    return axiosInstance.get(`/game-card-schedules/count-place/${gameId}`);
};

export const postPrivateGame = data => {
    return axiosInstance.post(`/private-game-requests`, data)
}

export const getGameInfo = (id) => {
    return axiosInstance.get(`/game-card-schedules/${id}/game-info`);
}

export const getMaxPointsForGame = gameId => {
    return axiosInstance.get(`/site/game/${gameId}/points`);
}

export const getPlayerById = (id) => {
    return axiosInstance.get(`/site/search-users`, {params:{id}});
}

export const checkDayOff = async (date) => {
  const response = await axiosInstance.get(`/site/private-game-requests/day-off`, {
    params: { date },
  });
  // { date, dayOff, shortDay, dayType }
  return response.data;
};

export const getRooms = async () => {
  const response = await axiosInstance.get(`/site/private-game-requests/rooms`);
  return response.data;
};

export const getSlotTemplates = async () => {
  const response = await axiosInstance.get(`/site/private-game-requests/slot-templates`);
  return response.data;
};

export const getWeekendSlots = async (startDate, endDate, roomId) => {
  const response = await axiosInstance.get(`/site/private-game-requests/weekend-slots`, {
    params: { startDate, endDate, roomId },
  });
  return response.data;
};

export const getFreeRooms = async (startAt, durationHours) => {
  const response = await axiosInstance.get(`/site/private-game-requests/free-rooms`, {
    params: { startAt, durationHours },
  });
  return response.data;
};

export const previewPrivateGame = async (data) => {
  const response = await axiosInstance.post(`/site/private-game-requests/preview`, data);
  return response.data;
};

export const createPrivateGame = async (data) => {
  const response = await axiosInstance.post(`/site/private-game-requests`, data);
  return response.data;
};

export const getMasters = async (gameSystemId) => {
  // Rules:
  // - gameSystemId === -1 OR undefined -> return ALL masters
  // - gameSystemId > 0 -> filtered masters
  const params =
    gameSystemId && Number(gameSystemId) > 0
      ? { gameSystemId: Number(gameSystemId) }
      : {}; // можно вообще не передавать параметр

  const response = await axiosInstance.get("/site/masters", { params });
  return response.data;
};